import { inject } from '@angular/core';
import { AuthService } from '../services/auth/auth.service';

export const appInitializer = () => {
  const authService = inject(AuthService);
  return authService.initialize();
};
